module.exports = __webpack_public_path__ + "img/view_booking.64cc6119.svg";